<template>
    <rkm-overlay>
        <rkm-layout-body title="Alto custo - Relatório estatístico de CID">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/farmacia/relatorio-alto-custo-estatistico-cid/List'

export default {
    components: { List },
}
</script>